import {
  MARK_AS_SHOWN,
  SET_PERSONAL_INFO,
  USER_IS_READY_FOR_NEW_PERSONAL_DATA,
} from '../../../../constants/centrifugo';

export const setPersonalInfo = (payload) => ({
  type: SET_PERSONAL_INFO,
  payload,
});

/**
 * @param payload - id of event
 * @returns {{payload, type: string}}
 */
export const markAsShown = (payload) => ({
  type: MARK_AS_SHOWN,
  payload,
});

export const setUserReadyForNewEvents = (payload) => ({
  type: USER_IS_READY_FOR_NEW_PERSONAL_DATA,
  payload,
});
